import { Registrar } from "@domainpage/shared/src";
var RegistrarDisplayCell = function (_a) {
    var cell = _a.cell;
    return cell.value ? Registrar["".concat(cell.value.toUpperCase(), "_DISPLAY")] : cell.value;
};
export default RegistrarDisplayCell;
